import React, { useState } from 'react';
import {
  TextField,
  Box,
  Button,
} from '@mui/material';
import { CommunityBoardDAO } from '../../../../repository/CommunityBoardDAO';
import { useToast, ToastType } from '../../../../context/toast/ToastContext';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import BaseModal from '../../../../components/modals/BaseModal';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';
import { useLoadingContext } from '../../../../context/loading/LoadingContext';

const EditPostModal = ({ show, onHide, post, onPostEdited }) => {
  const [topic, setTopic] = useState(post?.topic || '');
  const [content, setContent] = useState(post?.content || '');
  const [tags, setTags] = useState(post?.tags?.join(', ') || '');
  const [topicError, setTopicError] = useState(false);
  const [contentError, setContentError] = useState(false);
  const { showToast } = useToast();
  const { t } = useTranslation();
  const { setLoadingData } = useLoadingContext()
  const handleSubmit = async () => {
    let valid = true;

    if (!topic.trim()) {
      setTopicError(true);
      valid = false;
    }

    if (!content.trim()) {
      setContentError(true);
      valid = false;
    }

    if (!valid) return;

    try {
      setLoadingData(true)
      await CommunityBoardDAO.updatePost(post.id, {
        topic: topic.trim(),
        content: content.trim(),
        tags: tags.split(',').map(tag => tag.trim()).filter(tag => tag),
      });

      showToast('Post updated successfully', 'success');
      if (onPostEdited) onPostEdited();
      onHide();
    } catch (error) {
      console.error('Error updating post:', error);
      showToast('Failed to update post', 'error');
    } finally {
      setLoadingData(false)
    }
  };

  const actions = (
    <Button onClick={handleSubmit}>{t(StringKeys.SUBMIT)}</Button>
  );

  return (
    <BaseModal
      open={show}
      onClose={() => {
          onHide();
      }}
      actions={actions}
      title="Edit Post"
      submitText="Save Changes"
      submitDisabled={!topic.trim() || !content.trim()}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <TextField
          label={t(StringKeys.TOPIC)}
          value={topic}
          onChange={(e) => {
            setTopic(e.target.value);
            setTopicError(false);
          }}
          error={topicError}
          helperText={topicError ? 'Topic is required' : ''}
          fullWidth
          variant="outlined"
        />

        <Box sx={{ '& .quill': { height: '200px' } }}>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={(value) => {
              setContent(value);
              setContentError(false);
            }}
            placeholder={t(StringKeys.CONTENT)}
          />
          {contentError && (
            <Box sx={{ color: 'error.main', mt: 1, fontSize: '0.75rem' }}>
              {t(StringKeys.CONTENT_IS_REQUIRED)}
            </Box>
          )}
        </Box>
      </Box>
    </BaseModal>
  );
};

export default EditPostModal; 